import { render } from "./indexfourclinic.vue?vue&type=template&id=1acc6530"
import script from "./indexfourclinic.vue?vue&type=script&lang=js"
export * from "./indexfourclinic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__